// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m4WP","col":"styles_col__25ixO"};